<template>
  <div
    class="AuthRegister"
    data-cy-id="register-stage-contact-preferences"
    data-rmpdev-selector="update-user-form"
  >
    <h1 class="u-noMargin">
      Contact Preferences
    </h1>
    <p>Nobody likes a cluttered inbox. Tailor your email preferences to suit your needs.</p>

    <form
      ref="registration"
      class="Form"
    >
      <div
        class="Form-field"
        data-cy-id="register-email-options"
      >
        <p>What do YOU want the RMP Team to email you about?</p>
        <form-checkbox
          v-model="fields.jobs_subscription"
          :checked="fields.jobs_subscription"
          label="Job alerts"
          data-rmpdev-field-selector="jobs_subscription"
        />
        <p class="Hint">
          NEW (and relevant) jobs direct to your inbox... With expert careers advice
        </p>
        <form-checkbox
          v-model="fields.competitions_subscription"
          :checked="fields.competitions_subscription"
          label="Competitions and surveys"
          data-rmpdev-field-selector="competitions_subscription"
        />
        <p class="Hint">
          Complete surveys & competitions to win prizes from employers
        </p>
        <form-checkbox
            v-model="fields.courses_subscription"
            :checked="fields.courses_subscription"
            label="Apprenticeship Accelerator"
            data-rmpdev-field-selector="courses_subscription"
        />
        <p class="Hint">
          Opt in to receive exclusive invites to our free Apprenticeship Accelerator. This two-part virtual event series provides all the tools you need to kickstart your career
        </p>
      </div>
      <button
        :class="['Button Button--primary Button--long', {'is-loading' : ui.loading}]"
        @click.prevent="updateUser"
      >
        Next
      </button>
    </form>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import FormCheckbox from '@/components/form/checkbox';
import RegistrationStagesMixin from './registration-stages-mixin';

export default {

  components: {
    FormCheckbox,
  },

  mixins: [RegistrationStagesMixin],

  data() {
    return {
      v$: useVuelidate(),
      fields: {
        jobs_subscription: false,
        competitions_subscription: false,
        courses_subscription: false,
      },
      validateFields: false, // Skip validation for this stage. used in mixin
    };
  },
  validations() {
    const rules = {};

    return rules;
  },
  computed: {
    updatePayload() {
      return {
        jobs_subscription: this.fields.jobs_subscription,
        competitions_subscription: this.fields.competitions_subscription,
        courses_subscription: this.fields.courses_subscription,
      };
    },
  },
  mounted() {
    this.fields.jobs_subscription = !!this.user.jobs_subscription;
    this.fields.competitions_subscription = !!this.user.competitions_subscription;
    this.fields.courses_subscription = !!this.user.courses_subscription;
  },
};
</script>

<style scoped>
.Hint {
  margin-top: -1rem;
}
</style>
